module.exports = __webpack_public_path__ + "media/images/icons/tick-self-4684c78bb991116a8c81ba07f46e99d0.svg";